var _defs, _rect, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8765",
    "data-name": "Tracciato 8765",
    d: "M0,.533A.245.245,0,0,0,.244.779L3.119.794A.245.245,0,0,0,3.365.55l0-.533L0,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.163,
    y1: 14.305,
    x2: -1.124,
    y2: 14.305,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#eff6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#c5deff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#abd0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2cbff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8766",
    "data-name": "Tracciato 8766",
    d: "M0,4.751,2.8,7.3a.156.156,0,0,0,.258-.076l.873-3.547A1.317,1.317,0,0,0,3.728,2.6L1.878,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.8,
    y1: 2.185,
    x2: -1.767,
    y2: 2.185,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc7200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fc9f2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd661"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8767",
    "data-name": "Tracciato 8767",
    d: "M.249,2.591A1.317,1.317,0,0,0,.036,3.667L.886,7.22a.156.156,0,0,0,.257.078L3.962,4.763,2.116,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.013,
    y1: 2.191,
    x2: 0.046,
    y2: 2.191,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fc9f2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc7200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8768",
    "data-name": "Tracciato 8768",
    d: "M3.611,0C.43,2.591-1.333,10.782,1.226,14.676a.4.4,0,0,0,.33.194l3.972.021a.4.4,0,0,0,.332-.19C8.456,10.834,6.767,2.624,3.611,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.178,
    y1: 1.578,
    x2: 0.186,
    y2: 1.578,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#fbfcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#eff6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#dbebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#bfdbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2cbff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8769",
    "data-name": "Tracciato 8769",
    d: "M.109,4.536l0-.015c-.142,0-.16.007,0,.015M2.861,0A9.97,9.97,0,0,0,.114,4.522c.792-.014,5.456.037,5.456.037A10,10,0,0,0,2.861,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.274,
    y1: 3.834,
    x2: -0.255,
    y2: 3.834,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8770",
    "data-name": "Tracciato 8770",
    d: "M.36.742A1.831,1.831,0,1,0,1.833,0,1.831,1.831,0,0,0,.36.742",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.488,
    y1: 3.703,
    x2: -0.465,
    y2: 3.703,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcc715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#fcbf19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fca628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#fc9731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd9235"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8771",
    "data-name": "Tracciato 8771",
    d: "M1.264.016A1.482,1.482,0,1,0,1.485,0a1.5,1.5,0,0,0-.221.016",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.774,
    y1: 4.642,
    x2: -0.744,
    y2: 4.642,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2559cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#2255cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#1a49c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f38c1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8772",
    "data-name": "Tracciato 8772",
    d: "M2.387.12A1.362,1.362,0,0,1,2.4.667a.555.555,0,0,1-.338.358c-.229.083-.5.007-.718.108-.27.123-.386.464-.653.593a.705.705,0,0,1-.412.045A.593.593,0,0,1,0,1.664,1.482,1.482,0,1,0,2.378,0c0,.04,0,.08.01.12",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.951,
    y1: 5.075,
    x2: -0.918,
    y2: 5.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f38c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#133ec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#1f51ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2559cd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1978",
    "data-name": "Rettangolo 1978",
    width: 1.333,
    height: 0.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1979",
    "data-name": "Rettangolo 1979",
    width: 2.764,
    height: 14.145,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8776",
    "data-name": "Tracciato 8776",
    d: "M.115,1.756A6.343,6.343,0,0,0,0,3.063L.049,6.61A.524.524,0,0,0,1.1,6.615l.083-3.546a6.348,6.348,0,0,0-.1-1.309L.757,0l-.3,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -0.452,
    y1: 2.46,
    x2: -0.43,
    y2: 2.46,
    xlinkHref: "#linear-gradient-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5584",
    "data-name": "Raggruppa 5584",
    transform: "translate(-947 -167)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2490",
    "data-name": "Rettangolo 2490",
    width: 24,
    height: 24,
    transform: "translate(947 167)",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_546",
    "data-name": "Ellisse 546",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(949 169)",
    fill: "#f5f1ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5533",
    "data-name": "Raggruppa 5533",
    transform: "translate(950.667 169.153)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5477",
    "data-name": "Raggruppa 5477",
    transform: "translate(4.665 13.818) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4552",
    "data-name": "Raggruppa 4552",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1970",
    "data-name": "Rettangolo 1970",
    width: 3.368,
    height: 0.795,
    transform: "translate(-0.001 0)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5478",
    "data-name": "Raggruppa 5478",
    transform: "translate(9.932 11.346) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4554",
    "data-name": "Raggruppa 4554",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1971",
    "data-name": "Rettangolo 1971",
    width: 4.025,
    height: 7.386,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5479",
    "data-name": "Raggruppa 5479",
    transform: "translate(3.67 7.704) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4556",
    "data-name": "Raggruppa 4556",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1972",
    "data-name": "Rettangolo 1972",
    width: 4.015,
    height: 7.379,
    transform: "translate(-0.053 0)",
    fill: "url(#linear-gradient-3)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5480",
    "data-name": "Raggruppa 5480",
    transform: "translate(10.489 0) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4558",
    "data-name": "Raggruppa 4558",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1973",
    "data-name": "Rettangolo 1973",
    width: 17.452,
    height: 17.452,
    transform: "translate(-8.779 7.446) rotate(-45)",
    fill: "url(#linear-gradient-4)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5481",
    "data-name": "Raggruppa 5481",
    transform: "translate(11.139 0.375) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4560",
    "data-name": "Raggruppa 4560",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1974",
    "data-name": "Rettangolo 1974",
    width: 7.194,
    height: 7.194,
    transform: "translate(-2.325 2.279) rotate(-45)",
    fill: "url(#linear-gradient-5)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5482",
    "data-name": "Raggruppa 5482",
    transform: "translate(8.967 6.12) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4562",
    "data-name": "Raggruppa 4562",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1975",
    "data-name": "Rettangolo 1975",
    width: 5.694,
    height: 5.692,
    transform: "matrix(0.711, -0.703, 0.703, 0.711, -2.194, 1.932)",
    fill: "url(#linear-gradient-6)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5483",
    "data-name": "Raggruppa 5483",
    transform: "translate(9.094 6.595) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4564",
    "data-name": "Raggruppa 4564",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1976",
    "data-name": "Rettangolo 1976",
    width: 4.417,
    height: 4.417,
    transform: "translate(-1.64 1.536) rotate(-44.998)",
    fill: "url(#linear-gradient-7)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5484",
    "data-name": "Raggruppa 5484",
    transform: "translate(8.997 7.007) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4566",
    "data-name": "Raggruppa 4566",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1977",
    "data-name": "Rettangolo 1977",
    width: 3.956,
    height: 3.956,
    transform: "translate(-1.323 1.323) rotate(-44.998)",
    fill: "url(#linear-gradient-8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5485",
    "data-name": "Raggruppa 5485",
    transform: "translate(10.685 0.954) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5477-2",
    "data-name": "Raggruppa 5477",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4570",
    "data-name": "Raggruppa 4570",
    transform: "translate(1.764 5.93)",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4569",
    "data-name": "Raggruppa 4569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4568",
    "data-name": "Raggruppa 4568",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8773",
    "data-name": "Tracciato 8773",
    d: "M.208,0c-.032,0-.063,0-.1,0A.123.123,0,0,0,0,.138.123.123,0,0,0,.123.251H.134c.025,0,.05,0,.075,0A.123.123,0,0,0,.333.123.124.124,0,0,0,.208,0M.123.208Z",
    transform: "translate(1 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8774",
    "data-name": "Tracciato 8774",
    d: "M.793.01A.124.124,0,0,0,.7.009a1.24,1.24,0,0,0-.691.7A.124.124,0,0,0,.239.8.978.978,0,0,1,.791.238.124.124,0,0,0,.86.078.123.123,0,0,0,.793.01",
    transform: "translate(0 0.08)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4573",
    "data-name": "Raggruppa 4573",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4572",
    "data-name": "Raggruppa 4572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4571",
    "data-name": "Raggruppa 4571",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8775",
    "data-name": "Tracciato 8775",
    d: "M.625,13.267q.137.441.3.878H2.665q-.045-.073-.09-.149c-.074-.127-.146-.258-.216-.391-.139-.267-.266-.543-.387-.823a13.4,13.4,0,0,1-.594-1.742A14.036,14.036,0,0,1,.912,7.347a14.414,14.414,0,0,1,.132-1.884l.03-.236.04-.234L1.2,4.525l.1-.465.051-.233L1.41,3.6A18.639,18.639,0,0,1,2.764,0,18.849,18.849,0,0,0,1.02,3.472L.932,3.7l-.077.232L.7,4.4l-.135.473L.5,5.109l-.057.24a15.254,15.254,0,0,0-.264,5.941,14.753,14.753,0,0,0,.448,1.976",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5486",
    "data-name": "Raggruppa 5486",
    transform: "translate(7.481 11.132) rotate(30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4576",
    "data-name": "Raggruppa 4576",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1981",
    "data-name": "Rettangolo 1981",
    width: 5.887,
    height: 5.887,
    transform: "translate(-3.57 3.564) rotate(-45)",
    fill: "url(#linear-gradient-9)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.4b7b59f0a9500cbeb877477a0766dabe.svg";
export { ForwardRef as ReactComponent };